
<div class="val-grille">
  <kendo-grid #grille
              [valGrilleBinding]="donnees"
              [filtrageServeur]="filtrageServeur"
              [kendoGridSelectBy]="champSelection"
              [selectable]="{enabled: true, checkboxOnly: true, mode: modeSelection}"
              [navigable]="true"
              [rowClass]="RetournerCssClassLigneFocus"
              [groupable]="groupable"
              [group]="groupes"
              [resizable]="true"
              [reorderable]="true"
              [sortable]="sortSettings"
              [sort]="sort"
              [filterable]="filtrable"
              [filter]="filtres"
              [columnMenu]="menuColonne"
              [pageable]="pageable"
              [pageSize]="$any(pageable ? taillePage : undefined)"
              [skip]="skip"
              (pageChange)="PageChange($event)"
              (filterChange)="FiltresChange($event)"
              [(selectedKeys)]="donneesSelection.identifiantsSelectionnes"
              (cellClick)="CelluleClick($event)"
              (selectedKeysChange)="SelectionChange()"
              (scrollBottom)="DemanderDonneesSuivante()"
              (dblclick)="DoubleClick()"
              (sortChange)="TrisChange($event)"
              (columnReorder)="OrdreColonneChange($event)"
              (groupChange)="GroupeColonneChange($event)"
              (columnVisibilityChange)="VisibiliteColonneChange($event)"
              (columnResize)="TailleColonneChange($event)">
    
    <kendo-grid-messages [groupPanelEmpty]="Texte('grouper-ici', 'Faites glisser un en-tête de colonne et déposer ici pour grouper par cette colonne')"
                         [columnMenu]="Texte('choix-colonnes', 'Choix des colonnes')"
                         [columns]="Texte('colonnes', 'Colonnes')"
                         [columnsApply]="Texte('appliquer', 'Appliquer')"
                         [columnChooserSelectedColumnsCount]="Texte('colonnes-selectionnees', '{selectedColumnsCount} Colonnes sélectionnées')">
    </kendo-grid-messages>

    <ng-template kendoGridColumnMenuTemplate let-service="service">
      <kendo-grid-columnmenu-chooser [service]="service" 
                                     [expanded]="true">
      </kendo-grid-columnmenu-chooser>
    </ng-template>

    <kendo-grid-checkbox-column [showSelectAll]="true"
                                [width]="45"
                                [sticky]="true"
                                [resizable]="false"
                                [columnMenu]="false"
                                [includeInChooser]="false"
                                [hidden]="!colonneSelection">
    </kendo-grid-checkbox-column>

    @if (colonnes.length > 0) 
    {
      @for (colonne of colonnes; track $index) 
      {
        @switch (colonne.format)
        {
          @case ("TXT")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-texte-filtre-rapide [filter]="filtres"
                                         [nomChamp]="colonne.champ">
                </val-texte-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("INT")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="#"
                                [style]="{'text-align': 'right'}"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ FormatEntier(dataItem[colonne.champ]) }}</span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-numerique-filtre-rapide [filter]="filtres"
                                             [nomChamp]="colonne.champ"
                                             format="n0"
                                             [nombreDecimale]="0"
                                             [column]="column">
                </val-numerique-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("DAT") 
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="dd/MM/yyyy"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-date-filtre-rapide [filter]="filtres"
                                        [nomChamp]="colonne.champ"
                                        [column]="column">
                </val-date-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("DAT_H")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="dd/MM/yyyy HH:mm:ss"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-date-filtre-rapide [filter]="filtres"
                                        [nomChamp]="colonne.champ"
                                        [column]="column">
                </val-date-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("CUR")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="#.00 €"
                                [style]="{'text-align': 'right'}"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ FormatMonnaie(dataItem[colonne.champ]) }}</span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-numerique-filtre-rapide [filter]="filtres"
                                             [nomChamp]="colonne.champ"
                                             format="n2"
                                             [nombreDecimale]="2"
                                             [column]="column">
                </val-numerique-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("CUR_COLOR")
          {
            <!-- Montant colore : identique a CUR (valeur decimale, filtre et tri numeriques),
                 la couleur venant d'un champ distinct de la ligne et non de la valeur. -->
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="#.00 €"
                                [style]="{'text-align': 'right'}"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span [style.color]="RetournerCouleurMontant(dataItem)">{{ FormatMonnaie(dataItem[colonne.champ]) }}</span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-numerique-filtre-rapide [filter]="filtres"
                                             [nomChamp]="colonne.champ"
                                             format="n2"
                                             [nombreDecimale]="2"
                                             [column]="column">
                </val-numerique-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("CUR_SIGN")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                [style]="{'text-align': 'right'}"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ FormatMonnaieAvecSigne(dataItem[colonne.champ]) }}</span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-numerique-filtre-rapide [filter]="filtres"
                                             [nomChamp]="colonne.champ"
                                             format="n2"
                                             [nombreDecimale]="2"
                                             [column]="column">
                </val-numerique-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("DEC")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                format="#.00"
                                [style]="{'text-align': 'right'}"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ FormatDecimal(dataItem[colonne.champ]) }}</span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-numerique-filtre-rapide [filter]="filtres"
                                             [nomChamp]="colonne.champ"
                                             format="n2"
                                             [nombreDecimale]="2"
                                             [column]="column">
                </val-numerique-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("CHK") 
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible">
              <ng-template kendoGridCellTemplate let-dataItem>
                <input  type="checkbox"
                        [checked]="dataItem[colonne.champ]"
                        onclick="return false"/>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-boolean-filtre-rapide [filter]="filtres"
                                           [nomChamp]="colonne.champ">
                </val-boolean-filtre-rapide>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("TXT_COLOR")
          {
            <kendo-grid-column [field]="colonne.champ"
                               [title]="colonne.libelle"
                               [width]="colonne.taille"
                               [hidden]="!colonne.visible">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <val-texte-filtre-rapide [filter]="filtres"
                                         [nomChamp]="colonne.champ">
                </val-texte-filtre-rapide>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                <val-texte-couleur-colonne [valeur]="dataItem[colonne.champ]" [couleurParDefaut]="colonne.couleurParDefaut">
                </val-texte-couleur-colonne>
              </ng-template>
            </kendo-grid-column>
          }
          @case ("BTN_ICON")
          {
            <kendo-grid-column  [field]="colonne.champ"
                                [title]="colonne.libelle"
                                [width]="colonne.taille"
                                [hidden]="!colonne.visible"
                                [sortable]="false"
                                [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                @if (dataItem[colonne.champ])
                {
                  <val-fonte-icone [iconeCss]="dataItem[colonne.champ]"
                                   (click)="ColonneBoutonIconeClick(dataItem, colonne.champ, $event)"
                                   class="val-cursor-pointer">
                  </val-fonte-icone>
                }
              </ng-template>
            </kendo-grid-column>
          }        
        }
      }
    }
  </kendo-grid>
</div>
